(() => {
  const body = document.body;
  const menu = document.querySelector('#MobileMenu');
  const toggle = document.querySelector('.menu-toggle');
  const close = document.querySelector('.mobile-menu__close');
  const setMenu = (open) => {
    if (!menu || !toggle) return;
    menu.hidden = !open;
    toggle.setAttribute('aria-expanded', String(open));
    toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    body.classList.toggle('menu-open', open);
    if (open) close?.focus(); else toggle.focus();
  };
  toggle?.addEventListener('click', () => setMenu(toggle.getAttribute('aria-expanded') !== 'true'));
  close?.addEventListener('click', () => setMenu(false));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && menu && !menu.hidden) setMenu(false); });

  const filterToggle = document.querySelector('.filter-toggle');
  const filters = document.querySelector('#CollectionFilters');
  filterToggle?.addEventListener('click', () => {
    const open = filterToggle.getAttribute('aria-expanded') !== 'true';
    filterToggle.setAttribute('aria-expanded', String(open));
    filters?.classList.toggle('is-open', open);
  });

  const searchInput = document.querySelector('#SearchInput');
  const searchClear = document.querySelector('.search-clear');
  const syncSearchClear = () => { if (searchClear && searchInput) searchClear.hidden = !searchInput.value; };
  searchInput?.addEventListener('input', syncSearchClear);
  searchClear?.addEventListener('click', () => { searchInput.value = ''; syncSearchClear(); searchInput.focus(); });

  const openCareTarget = () => {
    if (!window.location.hash.startsWith('#care-')) return;
    const target = document.querySelector(window.location.hash);
    if (target?.matches('details')) target.open = true;
  };
  openCareTarget();
  window.addEventListener('hashchange', openCareTarget);

  document.querySelectorAll('[data-quantity-minus], [data-quantity-plus]').forEach((button) => {
    button.addEventListener('click', () => {
      const input = button.parentElement?.querySelector('input[type="number"]');
      if (!input) return;
      const delta = button.hasAttribute('data-quantity-plus') ? 1 : -1;
      input.value = String(Math.max(Number(input.min || 1), Number(input.value || 1) + delta));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  const galleryItems = [...document.querySelectorAll('[data-gallery-image]')];
  const lightbox = document.querySelector('[data-product-lightbox]');
  const lightboxImage = lightbox?.querySelector('[data-lightbox-image]');
  const lightboxCaption = lightbox?.querySelector('[data-lightbox-caption]');
  let activeGalleryIndex = 0;
  const showGalleryImage = (index) => {
    if (!lightbox || !lightboxImage || !galleryItems.length) return;
    activeGalleryIndex = (index + galleryItems.length) % galleryItems.length;
    const item = galleryItems[activeGalleryIndex];
    lightboxImage.src = item.dataset.gallerySrc || item.querySelector('img')?.currentSrc || '';
    lightboxImage.alt = item.dataset.galleryAlt || '';
    if (lightboxCaption) lightboxCaption.textContent = `${activeGalleryIndex + 1} / ${galleryItems.length}`;
  };
  galleryItems.forEach((item, index) => item.addEventListener('click', () => {
    showGalleryImage(index);
    lightbox?.showModal();
  }));
  lightbox?.querySelector('[data-lightbox-close]')?.addEventListener('click', () => lightbox.close());
  lightbox?.querySelector('[data-lightbox-previous]')?.addEventListener('click', () => showGalleryImage(activeGalleryIndex - 1));
  lightbox?.querySelector('[data-lightbox-next]')?.addEventListener('click', () => showGalleryImage(activeGalleryIndex + 1));
  lightbox?.addEventListener('click', (event) => { if (event.target === lightbox) lightbox.close(); });
  document.addEventListener('keydown', (event) => {
    if (!lightbox?.open) return;
    if (event.key === 'ArrowLeft') showGalleryImage(activeGalleryIndex - 1);
    if (event.key === 'ArrowRight') showGalleryImage(activeGalleryIndex + 1);
  });

  document.querySelectorAll('product-recommendations').forEach((element) => {
    if (!element.dataset.url) return;
    fetch(element.dataset.url).then((response) => response.text()).then((text) => {
      const html = document.createElement('div');
      html.innerHTML = text;
      const incoming = html.querySelector('product-recommendations');
      if (incoming?.innerHTML.trim()) element.innerHTML = incoming.innerHTML;
    }).catch(() => {});
  });

  const reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
      if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
    }), { threshold: .08 });
    reveals.forEach((item) => observer.observe(item));
  } else reveals.forEach((item) => item.classList.add('is-visible'));
})();
